import type { EventBusKey } from '@vueuse/core'

export const sclappEventKey: EventBusKey<string> = Symbol('symbol-key')